"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightSeatCount = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
require("./index.scss");
const className = 'flight-seat-count';
const FlightSeatCount = (props) => {
    const { value, allowedNegative } = props;
    const fixedValue = allowedNegative ? value : Math.max(value, 0);
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        fixedValue < 0 ? 'negative' : undefined,
    ]);
    return (react_1.default.createElement("div", { className: classNames }, fixedValue));
};
exports.FlightSeatCount = FlightSeatCount;
//# sourceMappingURL=index.js.map